// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { EllipsisWithTooltip } from "@design-system/EllipsisWithTooltip/EllipsisWithTooltip";
import React from "react";
import UncategorizedIcon from "@icons/transactionCategories/Uncategorized.svg?react";
import styles from "./HistoryCategory.module.scss";

interface Props {
    label: string;
}

export const DeletedCategory: React.FC<Props> = ({ label }) => (
    <EllipsisWithTooltip fullText={label ?? ""} overflowDirection="horizontal">
        {(ref) => (
            <span className={styles.deletedCategory}>
                <UncategorizedIcon className={styles.deletedCategoryIcon} />
                <span ref={ref}>{label}</span>
            </span>
        )}
    </EllipsisWithTooltip>
);
